import React, { ReactElement, SyntheticEvent } from 'react'
import translate, { getCurrentLanguageFromStorage } from 'helpers/translate'
import config from 'const/config'
import redirectToClientUrl from 'helpers/redirectToClientUrl'
import Stack from 'syf-component-library/ui/spacing/Stack'
import Inset from 'syf-component-library/ui/spacing/Inset'
import {
  ActionsContainer,
  GetStartedButton,
  SignInButton,
  SyfLogo,
  TryMeBannerHeader,
  TryMeContainer
} from './subcomponents'

const TryMeBanner = (): ReactElement => {
  const language = getCurrentLanguageFromStorage()
  const signInUrl = `${config.VISTA_DOMAIN}/accounts/?client=universal&ui_locales=${language}`
  const getStartedUrl = `${signInUrl}&prompt=register`

  const callGetStartedClick = (event: SyntheticEvent) => {
    event.preventDefault()
    redirectToClientUrl(getStartedUrl)
  }

  const callSignInClick = (event: SyntheticEvent): void => {
    event.preventDefault()
    redirectToClientUrl(signInUrl)
  }

  return (
    <React.Fragment key="TryMeBannerKey">
      <TryMeContainer>
        <Inset all="base">
          <SyfLogo />
          <Stack size="small" />
          <TryMeBannerHeader weight="bold">
            {translate({ string: 'getStartedNewSignIn' })}
          </TryMeBannerHeader>
          <Stack size="small" />
          <Stack size="small" />
          <ActionsContainer>
            <GetStartedButton
              buttonType="primary"
              className="ensightencustomevent"
              data-object="button"
              data-reason="try me banner"
              data-type="get started"
              onClick={callGetStartedClick}
              type="button"
            >
              {translate({ string: 'getStartedButton' })}
            </GetStartedButton>
            <SignInButton
              buttonType="primary"
              className="ensightencustomevent"
              data-object="button"
              data-reason="try me banner"
              data-type="sign in"
              onClick={callSignInClick}
              type="button"
            >
              {translate({ string: 'signInButton' })}
            </SignInButton>
          </ActionsContainer>
        </Inset>
      </TryMeContainer>
      <Stack size="medium" />
    </React.Fragment>
  )
}

export default TryMeBanner
